import { Client, Databases, ID, Query, Storage } from "appwrite";
import confiure from '../conifure'
import { useId } from "react";
export class Service{
    client = new Client()
    .setEndpoint(confiure.appwriteUrl)
    .setProject(confiure.projectId)

    database=new Databases(this.client)
    bucket=new Storage(this.client)
     async createPsot(Names,email,phone,message,subject,userId) {
        try {
            return await this.database.createDocument(confiure.databaseId,confiure.collectionId,ID.unique(),{
                Names,email,phone,message,subject,
                userId
            })
            
        } catch (error) {
            throw error
        }
    }
}

const service =new Service()

export default service; 